import { useMemo } from "react";
import * as geojson from "geojson";
import { useLayerStale } from "../../hooks/useLayerStale";
import { Layer } from "../../types/layer";
import { areaParts } from "./DataReviewAreaMaskLayer";

/** On a clean-slate refinement the ground inside the area counts as
 *  cleared until something is found or painted there: a dark wash over the
 *  vegetation inside the outline says so. The findings draw over it. */
const VegEditorClearedLayer = (id: string, area: geojson.Feature | null, visible: boolean): Layer => {
  const g = area?.geometry;
  const staleOf = useLayerStale();
  // The area as it is, every part with its own holes.
  const source = useMemo<geojson.FeatureCollection>(() => ({
    type: "FeatureCollection",
    features: areaParts(g).length ? [{ type: "Feature", properties: {}, geometry: g as geojson.Polygon | geojson.MultiPolygon }] : [],
  }), [g]);
  return {
    id,
    name: "Cleared ground",
    type: "data-review-cleared",
    source,
    layerStyle: [{ id, type: "fill", paint: { "fill-color": "#0b0f14", "fill-opacity": 0.55 } }],
    toolbarButton: null,
    active: visible && source.features.length > 0,
    ...staleOf(id, source),
  };
};

export default VegEditorClearedLayer;
